import {apiLink} from "../../app/routes/api_link";
import {getRequest} from "../../app/utils/request_response_utils/request";
import {catch404} from "../../app/utils/request_response_utils/response_error";

export const fetchSearchInvestmentById = (investmentId: string): Promise<{name: string}> => {
    const investmentApiLink = apiLink.investment.detail({})({investmentId});

    return getRequest({}, investmentApiLink).catch(catch404((err) => null));
};
